/**
 * JWT decoding and docs access role resolution.
 */

import { docsTierForRole } from '../workspaceAccess';

export function decodeJwtPayload(jwt) {
  if (!jwt || typeof jwt !== 'string') return null;
  const parts = jwt.split('.');
  if (parts.length < 2) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '==='.slice((b64.length + 3) % 4);
    const json = atob(padded);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * Docs access: `user` = User notes only; `admin` = User + Admin internal notes.
 * @returns {'admin' | 'user'}
 */
export function resolveFokusRoleFromIdToken(idTokenJwt) {
  const payload = decodeJwtPayload(idTokenJwt);
  if (payload) {
    const raw = payload['custom:fokusRole'] ?? payload.fokus_role ?? payload['custom:role'];
    if (raw === 'user' || raw === 'admin') return raw;
  }
  return 'admin';
}

/** Map workspace MEMBER role to docs UI tier (Mission Full View tabs). */
export function workspaceRoleToDocsRole(memberRole) {
  return docsTierForRole(memberRole);
}

export async function checkAppPermission(userId, _resourceIds, _requiredRoles, idTokenJwt) {
  if (!userId) {
    return { hasAccess: false, role: null };
  }
  return { hasAccess: true, role: resolveFokusRoleFromIdToken(idTokenJwt) };
}
